import { z } from "zod";

export const answerCategorySchema = z.enum([
  "visa", "experience", "salary", "availability", "relocation",
  "education", "skills", "motivation", "other",
]);

export const autoApplyAnswerSchema = z.object({
  id: z.string(),
  userId: z.string(),
  questionPattern: z.string().min(1),
  answerText: z.string().min(1),
  category: answerCategorySchema.nullable(),
  platform: z.string().nullable(),
  usageCount: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const createAnswerInput = z.object({
  questionPattern: z.string().min(1).max(500),
  answerText: z.string().min(1).max(2000),
  category: answerCategorySchema.optional(),
  platform: z.string().optional(),
});

export const updateAnswerInput = z.object({
  id: z.string(),
  questionPattern: z.string().min(1).max(500).optional(),
  answerText: z.string().min(1).max(2000).optional(),
  category: answerCategorySchema.nullable().optional(),
  platform: z.string().nullable().optional(),
});

export const answerQuestionInput = z.object({
  questionText: z.string().min(1),
  jobId: z.string().optional(),
  platform: z.string().optional(),
  context: z.string().optional(),  // additional context like job description snippet
});

export type AutoApplyAnswer = z.infer<typeof autoApplyAnswerSchema>;
export type CreateAnswerInput = z.infer<typeof createAnswerInput>;
export type AnswerQuestionInput = z.infer<typeof answerQuestionInput>;
